import type { ReactNode } from "react";
import { cn } from "@/lib/cn";

/**
 * Status pill. `tone` maps to the exam semantics defined in docs/DESIGN.md:
 * answered=green, review=amber, violation=red, neutral=gray, accent=blue.
 */
export type BadgeTone =
  | "neutral"
  | "answered"
  | "review"
  | "violation"
  | "accent";

const TONES: Record<BadgeTone, string> = {
  neutral: "bg-neutral-soft text-ink-muted border-border",
  answered: "bg-answered-soft text-answered border-answered/25",
  review: "bg-review-soft text-review border-review/25",
  violation: "bg-violation-soft text-violation border-violation/25",
  accent: "bg-accent-soft text-accent border-accent/25",
};

export function Badge({
  tone = "neutral",
  className,
  children,
}: {
  tone?: BadgeTone;
  className?: string;
  children: ReactNode;
}) {
  return (
    <span
      className={cn(
        "inline-flex items-center gap-1 rounded-sm border px-1.5 py-0.5",
        "text-2xs font-medium whitespace-nowrap",
        TONES[tone],
        className,
      )}
    >
      {children}
    </span>
  );
}
